import type { TurnoDePaciente } from '@medchoice/shared';
import { Enlace, irA } from '../../router';
import { Icono, InsigniaEstadoTurno, Tarjeta } from '../../ui';

const MESES = ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'];

export function TarjetaDeTurno({ turno: t }: { turno: TurnoDePaciente }) {
  const fecha = new Date(`${t.fecha}T12:00:00`);
  const debeResena = t.estado === 'atendido' && !t.tiene_resena;
  return (
    <Tarjeta resaltable alPulsar={() => irA(`/turno/${t.id_turno}`)} etiqueta={`Turno con ${t.profesional.nombre} ${t.profesional.apellido}`}>
      <div className="turno">
        <div className="turno__fecha">
          <span>{MESES[fecha.getMonth()]}</span>
          <strong>{fecha.getDate()}</strong>
        </div>
        <div className="turno__datos">
          <h3>{t.profesional.nombre} {t.profesional.apellido}</h3>
          <p>{t.profesional.especialidad} · {t.servicio}</p>
          <p className="turno__hora">
            <Icono nombre={t.modalidad === 'videoconsulta' ? 'message-circle' : 'clock'} tamano={14} />
            {t.hora_inicio} a {t.hora_fin} <span className="codigo">#{t.codigo}</span>
          </p>
        </div>
        <InsigniaEstadoTurno estado={t.estado} />
      </div>
      {debeResena && (
        <div className="turno__resena">
          <Icono nombre="star" tamano={15} /> ¿Cómo te fue? <Enlace a={`/resena/${t.id_turno}`}>Dejar reseña</Enlace>
        </div>
      )}
    </Tarjeta>
  );
}
